module.exports = __webpack_public_path__ + "img/comment-icon-white.0857c6d4.svg";